import { useEffect } from "react";
import { motion, useReducedMotion } from "framer-motion";

const pieces = Array.from({ length: 18 }, (_, index) => ({
    id: index,
    left: 6 + ((index * 29) % 88),
    delay: (index % 6) * 0.04,
    color: ["#14b8a6", "#2dd4bf", "#f59e0b", "#6366f1", "#ec4899"][index % 5],
    drift: ((index % 5) - 2) * 24,
}));

const CelebrationBurst = ({ active, onComplete }) => {
    const reduceMotion = useReducedMotion();

    useEffect(() => {
        if (active && reduceMotion) onComplete?.();
    }, [active, onComplete, reduceMotion]);

    if (!active || reduceMotion) return null;

    return (
        <motion.div
            className="pointer-events-none fixed inset-0 z-[320] overflow-hidden"
            aria-hidden="true"
            initial={{ opacity: 1 }}
            animate={{ opacity: [1, 1, 0] }}
            transition={{ duration: 1.35, times: [0, 0.75, 1] }}
            onAnimationComplete={onComplete}
        >
            {pieces.map((piece) => (
                <motion.span
                    key={piece.id}
                    className="absolute top-0 h-3 w-2 rounded-sm"
                    style={{ left: `${piece.left}%`, backgroundColor: piece.color }}
                    initial={{ y: -24, x: 0, rotate: 0 }}
                    animate={{
                        y: "95vh",
                        x: piece.drift,
                        rotate: piece.id % 2 === 0 ? 540 : -540,
                    }}
                    transition={{
                        duration: 1.05 + (piece.id % 4) * 0.08,
                        delay: piece.delay,
                        ease: "easeIn",
                    }}
                />
            ))}
        </motion.div>
    );
};

export default CelebrationBurst;
